var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"cars-list-page"}},[_c('base-header',{attrs:{"titulo":_vm.$tc('analyze-deforestation.words.title')}}),_c('div',{staticClass:"view-container"},[_c('filters'),_c('div',{staticStyle:{"margin-top":"40px"}}),_c('report-analyze-list')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }